import BaseApi from './baseApi';
import IOutboundDeliveryNotesDetail from '../models/IOutboundDeliveryNotesDetail';
import IAuthentication from '../models/IAuthentication';
export default class OutboundDeliveryNotesDetailApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Outbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetOutboundDeliveryNotesDetail(idOutboundDeliveryNote: string) : Promise<IOutboundDeliveryNotesDetail[]> {
        let json : string = this.getJsonRead(idOutboundDeliveryNote);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outboundDeliveryNotesDetails: IOutboundDeliveryNotesDetail[] = [];
            outboundDeliveryNotesDetails = response.data as IOutboundDeliveryNotesDetail[];
            return outboundDeliveryNotesDetails;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveOutboundDeliveryNotesDetail(outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) : Promise<string> {
        const json = this.getJsonSave(outboundDeliveryNotesDetail);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateOutboundDeliveryNotesDetail(outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) : Promise<boolean> {
        const json = this.getJsonUpdate(outboundDeliveryNotesDetail);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDeliveryNotesDetail(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDeliveryNotesDetailByOutboundDetailId(outboundDetailId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByOutboundDetailId(outboundDetailId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDeliveryNotesDetailByOutboundDeliveryNoteId(outboundDeliveryNoteId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByOutboundDeliveryNoteId(outboundDeliveryNoteId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDeliveryNotesDetailByOutboundId(outboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByOutboundId(outboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByOutboundId(outboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotesDetail",
            "conditions": [{
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "IdOutboundDeliveryNote",
                "Item3": "IN",
                "Item4": "(SELECT Id FROM OutboundsDeliveryNotes WHERE IdOutbound = '" + outboundId + "')"
            }]
        };
        return json;
    }

    private getJsonDeleteByOutboundDetailId(outboundDetailId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotesDetail",
            "KeyName": "IdOutboundDetail",
            "KeyValue": outboundDetailId
        };
        return json;
    }

    private getJsonDeleteByOutboundDeliveryNoteId(outboundDeliveryNoteId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotesDetail",
            "conditions": [{
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "idOutboundDeliveryNote",
                "Item3": "=",
                "Item4": outboundDeliveryNoteId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotesDetail",
            "conditions": [{
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idOutboundDeliveryNote",
                "Item2": outboundDeliveryNotesDetail.idOutboundDeliveryNote
            }, {
                "Item1": "idOutboundDetail",
                "Item2": outboundDeliveryNotesDetail.idOutboundDetail
            }, {
                "Item1": "idGood",
                "Item2": outboundDeliveryNotesDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": outboundDeliveryNotesDetail.idListPallet
            }, {
                "Item1": "idPallet",
                "Item2": outboundDeliveryNotesDetail.idPallet
            }, {
                "Item1": "casesPerPallet",
                "Item2": outboundDeliveryNotesDetail.casesPerPallet
            }, {
                "Item1": "totalCases",
                "Item2": outboundDeliveryNotesDetail.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": outboundDeliveryNotesDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": outboundDeliveryNotesDetail.totalGoods
            }, {
                "Item1": "weight",
                "Item2": outboundDeliveryNotesDetail.weight
            }, {
                "Item1": "bestBeforeDate",
                "Item2": outboundDeliveryNotesDetail.bestBeforeDate
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotesDetail"
        };
        return json;
    }

    private getJsonUpdate(outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idOutboundDeliveryNote",
                "Item2": outboundDeliveryNotesDetail.idOutboundDeliveryNote
            }, {
                "Item1": "idOutboundDetail",
                "Item2": outboundDeliveryNotesDetail.idOutboundDetail
            }, {
                "Item1": "idGood",
                "Item2": outboundDeliveryNotesDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": outboundDeliveryNotesDetail.idListPallet
            }, {
                "Item1": "idPallet",
                "Item2": outboundDeliveryNotesDetail.idPallet
            }, {
                "Item1": "casesPerPallet",
                "Item2": outboundDeliveryNotesDetail.casesPerPallet
            }, {
                "Item1": "totalCases",
                "Item2": outboundDeliveryNotesDetail.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": outboundDeliveryNotesDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": outboundDeliveryNotesDetail.totalGoods
            }, {
                "Item1": "weight",
                "Item2": outboundDeliveryNotesDetail.weight
            }, {
                "Item1": "bestBeforeDate",
                "Item2": outboundDeliveryNotesDetail.bestBeforeDate
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotesDetail",
            "keyvalue": outboundDeliveryNotesDetail.id
        };
        return json;
    }

    private getJsonRead(idOutboundDeliveryNote: string) : any {
        const json = {
            "fields": [{
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "id"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "idOutboundDeliveryNote"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "idOutboundDetail"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "idGood"
            }, {
                "Item1": "",
                "Item2": "(select Name from Goods where id = OutboundsDeliveryNotesDetail.IdGood) as goodName"
            }, {
                "Item1": "",
                "Item2": "(select Code from Goods where id = OutboundsDeliveryNotesDetail.IdGood) as goodCode"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListPalletTypes where id = OutboundsDeliveryNotesDetail.idListPallet) as palletName"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "totalCases"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "totalGoods"
            }, {
                "Item1": "",
                "Item2": "ISNULL((SELECT SUM(CasesPerPallet) FROM OutboundsNoticeOfLossDetail WHERE IdOutboundDeliveryNoteDetail = OutboundsDeliveryNotesDetail.Id), 0) AS CasesLoss"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "weight"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "SCAN_StockDetailScan",
                "Item2": "IdPalletCustomer"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }],
            "tables": [{
                "Item1": "OutboundsDeliveryNotesDetail"
            }, {
                "Item1": "OutboundsDetail"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "SCAN_StockDetailScan"
            }, {
                "Item1": "StockDetail"
            }],
            "joins": [{
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "OutboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "idInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "IdPallet",
                "Item3": "SCAN_StockDetailScan",
                "Item4": "IdPallet"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "Id",
                "Item3": "StockDetail",
                "Item4": "IdOutboundDeliveryNoteDetail"
            }],
            "conditions": [{
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "OutboundsDeliveryNotesDetail",
                "Item2": "idOutboundDeliveryNote",
                "Item3": "=",
                "Item4": idOutboundDeliveryNote
            }],
            "groupby": [
                { "Item1": "StockDetail.location" },
                { "Item1": "OutboundsDeliveryNotesDetail.id" },
                { "Item1": "OutboundsDeliveryNotesDetail.idOutboundDeliveryNote" },
                { "Item1": "OutboundsDeliveryNotesDetail.idOutboundDetail" },
                { "Item1": "OutboundsDeliveryNotesDetail.idGood" },
                { "Item1": "OutboundsDeliveryNotesDetail.idListPallet" },
                { "Item1": "OutboundsDeliveryNotesDetail.idPallet" },
                { "Item1": "OutboundsDeliveryNotesDetail.casesPerPallet" },
                { "Item1": "OutboundsDeliveryNotesDetail.totalCases" },
                { "Item1": "OutboundsDeliveryNotesDetail.goodsPerCase" },
                { "Item1": "OutboundsDeliveryNotesDetail.totalGoods" },
                { "Item1": "OutboundsDeliveryNotesDetail.weight" },
                { "Item1": "OutboundsDeliveryNotesDetail.bestBeforeDate" },
                { "Item1": "InboundsDetail.language" },
                { "Item1": "SCAN_StockDetailScan.IdPalletCustomer" }]
        };
        return json;
    }
}
